var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-header",attrs:{"id":"header"}},[_c('div',{staticClass:"auth-title-header"},[_c('img',{attrs:{"src":"https://s3-us-west-2.amazonaws.com/cdn-yeeko/static/img/logo.png","alt":"Logo Yeeko","width":"150"}})])])
}]

export { render, staticRenderFns }